export const ERROR_PREFIX = "Error: "; // prefix for error messages in redux store (helpful when error message is an empty string)
export const ORDERS_PAGE_SIZE = 3;
